export default __webpack_public_path__ + "566bda57043140ec07de1d5827c3bd2a.png";